(ns common.resource.query.campaign
  (:require [camel-snake-kebab.core :as csk]
            [camel-snake-kebab.extras :as cske]
            [cljs-bean.core :refer [->clj]]
            [common.db.effects.http :refer [jsonify]]
            [common.queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(def entity-name "campaing")

(defn adset-count [campaign]
  (+ (count (:adsetIds campaign)) (count (:adset2Ids campaign))))

(defn transform-campaigns [^js data]
  (->> (->clj data)
       (filterv (fn [campaign]
                  (not= "dynamicInputs" (:type campaign))))
       (mapv (fn [campaign]
               (assoc campaign :adset-count (adset-count campaign))))))

(defn campaigns-query [{:keys [advertiser-id]}]
  #js {:queryKey #js ["campaigns" advertiser-id]
       :queryFn (fn [_ctx] (qhttp/get (qhttp/render :api/campaigns {}
                                                    {:filters (jsonify {:advertiserId advertiser-id})})))
       :select transform-campaigns
       :enabled (boolean advertiser-id)})

(defn transform-stats [^js data]
  (->> (->clj data)
       (mapv (fn [{:keys [campaign-id impressions clicks]}]
               {:id campaign-id
                :impressions impressions
                :clicks clicks
                :ctr (/ clicks impressions)}))))

(defn campaigns-stats-query [{:keys [advertiser-id daterange]}]
  #js {:queryKey #js ["campaigns-stats" advertiser-id daterange]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :measure-api/campaign-stats {}
                                           (->> (merge daterange
                                                       {:advertiser-id advertiser-id})
                                                (cske/transform-keys csk/->snake_case)))))
       :select transform-stats
       :staleTime (* 60 1000)})

(defn campaign-query [{:keys [campaign-id]}]
  #js {:queryKey #js ["campaign" campaign-id]
       :queryFn (fn [_ctx] (qhttp/get (qhttp/render :api/campaign {:campaign-id campaign-id})))
       :enabled (boolean campaign-id)
       :throwOnError true})

(defn create-campaign-mutation [{:keys [advertiser-id]}]
  #js {:mutationKey #js ["create-campaign" advertiser-id]
       :mutationFn (fn [campaign]
                     (qhttp/post (qhttp/render :api/v0-campaigns {})
                                 {:body (assoc campaign :advertiserId advertiser-id)}))
       :onSuccess (fn []
                    (invalidate-queries {:queryKey ["campaigns" advertiser-id]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name entity-name
                                   :type :success
                                   :message "Successfully created campaign"}]))
       :onError (fn [error]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name entity-name
                                 :type :error
                                 :message "Failed to create campaign"
                                 :response (->clj (:data error))}]))})

(defn patch-campaign-mutation [{:keys [campaign-id]}]
  #js {:mutationKey #js ["patch-campaign" campaign-id]
       :mutationFn (fn [payload]
                     (qhttp/patch (qhttp/render :api/campaign {:campaign-id campaign-id})
                                  {:body payload}))
       :onMutate (fn []
                   (rf/dispatch [:loader/open]))
       :onSettled (fn []
                    (rf/dispatch [:loader/close]))
       :onSuccess (fn []
                    (invalidate-queries {:queryKey ["campaign" campaign-id]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name entity-name
                                   :type :success
                                   :message "Successfully saved campaign"}]))
       :onError (fn [error]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name entity-name
                                 :type :error
                                 :message "Failed to save campaign"
                                 :response (->clj (:data error))}]))})

(defn patch-campaign-wpp-project [{:keys [campaign-id]}]
  #js {:mutationKey #js ["patch-campaign-wpp-project" campaign-id]
       :mutationFn (fn [payload]
                     (qhttp/patch (qhttp/render :api/campaign-link-wpp-project {:campaign-id campaign-id})
                                  {:body payload}))
       :onMutate (fn []
                   (rf/dispatch [:loader/open]))
       :onSettled (fn []
                    (rf/dispatch [:loader/close]))
       :onSuccess (fn []
                    (invalidate-queries {:queryKey ["campaign" campaign-id]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name entity-name
                                   :type :success
                                   :message "Successfully linked campaign"}]))
       :onError (fn [error]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name entity-name
                                 :type :error
                                 :message "Failed to link campaign"
                                 :response (->clj (:data error))}]))})
